const apiUrl = process.env.REACT_APP_API_URL;
export const PostInscripcionsAlumneDownload = async ( id_inscripcio: string, id: string, json : any,  page : string) => {
    try {
        const response = await fetch(`${apiUrl}:8071/inscripcions/${id_inscripcio}/alumne/${id}/download`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(json)
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
